var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import { DocumentCardType, Dropdown, Icon, SearchBox } from "office-ui-fabric-react";
import * as React from "react";
import { OfficeHostType } from "../interfaces/index";
import { DocumentCardBasic } from "./DocumentCardBasic";
export var TemplateSelection = function TemplateSelection(props) {
  var _a = React.useState(),
      templates = _a[0],
      setTemplates = _a[1];

  var _b = React.useState(),
      selectedTag = _b[0],
      setTag = _b[1];

  var _c = React.useState(),
      filterQuery = _c[0],
      setFilter = _c[1];

  React.useEffect(function () {
    setTemplates(props.templates);
  }, [props.templates]);
  var templateCards = [];

  if (templates) {
    templates.forEach(function (template) {
      if (template.hostType != OfficeHostType.Unknown) templateCards.push(React.createElement(DocumentCardBasic, {
        onClick: props.selectTemplate,
        cardType: DocumentCardType.compact,
        template: template,
        strings: props.strings
      }));
    });
  }

  var uniqueTags = [{
    key: "",
    text: ""
  }];

  if (props.templates) {
    props.templates.forEach(function (template) {
      if (template.tags) template.tags.forEach(function (tag) {
        if (uniqueTags.findIndex(function (o) {
          return o.text == tag;
        }) < 0) {
          var option = {
            key: tag,
            text: tag
          };
          uniqueTags.push(option);
        }
      });
    });
  }

  var filterTemplates = function filterTemplates(filter) {
    setFilter(filter);

    var filteredTemplates = __spreadArrays(props.templates);

    if (selectedTag) {
      filteredTemplates = filteredTemplates.filter(function (t) {
        return t.tags && t.tags.indexOf(selectedTag) >= 0;
      });
    }

    if (filteredTemplates && filter) {
      filteredTemplates = filteredTemplates.filter(function (t) {
        return t.title.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    }

    setTemplates(filteredTemplates);
  };

  var filterTags = function filterTags(filter) {
    setTag(filter);

    var filteredTemplates = __spreadArrays(props.templates);

    if (filterQuery) {
      filteredTemplates = filteredTemplates.filter(function (t) {
        return t.title.toLowerCase().indexOf(filterQuery.toLowerCase()) >= 0;
      });
    }

    if (filteredTemplates && filter) {
      filteredTemplates = filteredTemplates.filter(function (t) {
        return t.tags && t.tags.indexOf(filter) >= 0;
      });
    }

    setTemplates(filteredTemplates);
  };

  return React.createElement("div", null, React.createElement("div", {
    className: "subTitle"
  }, React.createElement(Icon, {
    iconName: "ChevronLeftSmall",
    title: "Back",
    onClick: props.cancel,
    className: "backIcon"
  }), React.createElement("span", null, props.strings.SelectTemplate), React.createElement("div", {
    className: "searchbar"
  }, React.createElement(SearchBox, {
    placeholder: props.strings.SearchText,
    onSearch: function onSearch(value) {
      filterTemplates(value);
    },
    onChange: function onChange(_, value) {
      filterTemplates(value);
    }
  })), React.createElement("div", {
    className: "tagbar"
  }, React.createElement(Dropdown, {
    placeholder: props.strings.SelectTag,
    options: uniqueTags,
    onChange: function onChange(e, option) {
      filterTags(option === null || option === void 0 ? void 0 : option.text);
    }
  }))), React.createElement("div", {
    className: "templates"
  }, templateCards, templateCards.length == 0 && React.createElement("div", null, props.strings.NoTemplatesFound), React.createElement("div", {
    style: {
      clear: "both"
    }
  })));
};